module.exports = function() {
  return new Worker(__webpack_public_path__ + "c89a03191c0ec820ebfd.worker.js");
};